import Modal from "./Modal";



const AskDrivePulleyEditModal = ({ visible, onConfirm, onCancel, }) => {

    return (
        <Modal visible={visible} title="Warning" onConfirm={onConfirm} onCancel={onCancel} >
            <div>
                <p>드라이브 풀리를 수정하기 위해 컨베이어 편집창으로 이동하시겠습니까?</p>
            </div>
        </Modal>
    );
};

export default AskDrivePulleyEditModal;